import { useEffect, useState } from "react";
import api from "./api";

// How this instance bills and what the admin shows (GET /api/billing/display, set per instance by Kambaa):
// billing_mode "tokens" | "conversations"; show_token_details false hides token / cost / credit figures.
// Until it has loaded, token figures are treated as hidden so they never flash on screens that hide them.

let cached = null;
let pending = null;

const load = (force = false) => {
  if (!force && cached) return Promise.resolve(cached);
  if (!force && pending) return pending;
  pending = api.request("/api/billing/display", { skipToast: true })
    .then((res) => { cached = res || null; return cached; })
    .catch(() => null)
    .finally(() => { pending = null; });
  return pending;
};

export const refreshBillingDisplay = () => load(true);

export const useBillingDisplay = () => {
  const [display, setDisplay] = useState(cached);
  useEffect(() => {
    let alive = true;
    load().then((d) => { if (alive && d) setDisplay(d); });
    const onChange = () => load(true).then((d) => { if (alive && d) setDisplay(d); });
    window.addEventListener("payment_success", onChange);
    window.addEventListener("credits_updated", onChange);
    return () => {
      alive = false;
      window.removeEventListener("payment_success", onChange);
      window.removeEventListener("credits_updated", onChange);
    };
  }, []);
  return {
    loaded: !!display,
    showTokens: !!display && display.show_token_details !== false,
    conversationBilling: !!display && display.billing_mode === "conversations",
    usage: display ? display.usage : null,
    plans: display ? display.plans : null,
    pack: display ? display.pack : null,
  };
};
